import { render, staticRenderFns } from "./Abouts.vue?vue&type=template&id=fa09c256"
import script from "./Abouts.vue?vue&type=script&lang=js"
export * from "./Abouts.vue?vue&type=script&lang=js"
import style0 from "./Abouts.vue?vue&type=style&index=0&id=fa09c256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports